import React from "react";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useSnackbar } from "@components";
import {
  Box,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Refresh as RefreshIcon,
  FileDownload as FileDownloadIcon,
  Cancel as CancelIcon,
  WifiOff as WifiOffIcon,
  Sync as SyncIcon,
} from "@mui/icons-material";

import {
  useWorkflowContainerFulls,
  workflowContainerFullDelete,
  generateWfFullPdfReportbyId,
  getAllClientProducers,
  getAllClientProducerFarms,
  getAllClientsNoPagination,
  validTaskCodeByToken,
  getClientIdByToken,
  generateWfFullPdfTarjabyId,
  downloadWfFullFilesById,
} from "../../../../libs/apis";
import {
  ClientI,
  ClientProducerFarmI,
  ClientProducerI,
  WorkflowContainerFullI,
} from "../../../../libs/interfaces";
import {
  HEIGHT_TABLE_CONTAINER,
  TASK_FULL_CREATE_PDF,
  TASK_FULL_EDIT_CODE,
  TASK_FULL_FILTER_LIST,
} from "../../../../libs/constants";
import {
  ButtonQr,
  ExcelComponent,
  NetworkStatusAlert,
  PdfElement,
  SendReport,
} from "../../../../libs/shared";
import { useWidth } from "../../../../libs/hooks";
import { useNavigate } from "react-router-dom";
import "../../../../libs/css/list.css";
import {
  Button as ButtonAntd,
  Tooltip as TooltipAntd,
  Popconfirm,
  message,
  Select,
  ConfigProvider,
  Empty,
  DatePicker,
  Modal,
} from "antd";
import {
  DeleteFilled,
  EditOutlined,
  ExceptionOutlined,
  FilePdfOutlined,
  FilterOutlined,
  FileZipFilled,
  SearchOutlined,
} from "@ant-design/icons";
import { ShowContainer } from "./show-container";
import ComponentModalTarjaText from "./tarja-modal";

interface PaginationStateI {
  pageIndex: number;
  pageSize: number;
}

const titleExport: string = "ContenedorFull";
const routeEdit: string = "/container/full/edit/";
const { RangePicker } = DatePicker;

const WorkflowListComponent: React.FC = () => {
  const width = useWidth();
  const isMobile = width === "xs" || width === "sm" || width === "md";
  const isMaxMobile = width === "xs" || width === "sm";
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [sorting, setSorting] = React.useState<
    Array<{ id: string; desc: boolean }>
  >([{ id: "id", desc: true }]);
  const [pagination, setPagination] = React.useState<PaginationStateI>({
    pageIndex: 0,
    pageSize: width === "ab" ? 25 : width === "xl" ? 20 : 15,
  });
  const [globalFilter, setGlobalFilter] = React.useState<string>("");
  const [producer, setProducer] = React.useState<number | null>(null);
  const [producers, setProducers] = React.useState<ClientProducerI[]>([]);
  const [farm, setFarm] = React.useState<number | null>(null);
  const [farms, setFarms] = React.useState<ClientProducerFarmI[]>([]);
  const [client, setClient] = React.useState<number | null>(null);
  const [clients, setClients] = React.useState<ClientI[]>([]);

  // Estado para controlar si estamos en modo offline
  const [isOffline, setIsOffline] = React.useState<boolean>(!navigator.onLine);

  const [range, setRange] = React.useState([] as unknown as [string, string]);
  const [rangeVal, setRangeVal] = React.useState<any>([]);
  const { workflowContainerFullsQuery } = useWorkflowContainerFulls({
    sorting,
    pagination,
    globalFilter,
    client,
    producer,
    farm,
    range,
    rangeVal,
  });
  const { data, isLoading, refetch, isFetching, isRefetching, error } =
    workflowContainerFullsQuery;
  const [rowSelection, setRowSelection] = React.useState<Record<string, any>>(
    {}
  );
  const [isDeleting, setDeleting] = React.useState<boolean>(false);
  const [getExportData, setExportData] = React.useState<
    WorkflowContainerFullI[]
  >([]);
  const [getExportHeader, setExportHeader] = React.useState<
    Array<{
      label: string;
      id: string;
      width: number;
      textAlign: string;
      show: boolean;
      fontSize: string;
    }>
  >([]);
  const [isContinuoToExport, setContinuoToExport] =
    React.useState<boolean>(false);
  const [isReadyExport, setReadyExport] = React.useState<boolean>(false);
  const [isGeneratingPdf, setGeneratingPdf] = React.useState<boolean>(false);
  const [showExporters, setShowExporters] = React.useState<boolean>(false);
  const [showEdit, setShowEdit] = React.useState<boolean>(false);
  const [showPdf, setShowPdf] = React.useState<boolean>(false);
  const [downloadFile, setDownloadFile] = React.useState<boolean>(false);
  const [showMobileFilters, setShowMobileFilters] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  React.useLayoutEffect(() => {
    handleGetTask();
  }, []);

  React.useEffect(() => {
    handleGetData();
    return () => {
      setShowExporters(false);
    };
  }, []);

  React.useEffect(() => {
    if (isContinuoToExport) {
      setContinuoToExport(false);
      setReadyExport(true);
    }
  }, [isContinuoToExport]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDownloadFiles = React.useCallback(
    async (row: WorkflowContainerFullI): Promise<void> => {
      // Validar si estamos en modo offline
      if (isOffline) {
        message.warning("No se pueden eliminar registros sin conexión", 3);
        return;
      }

      try {
        // Recibe el blob desde la API
        setDownloadFile(true);
        const blobData = await downloadWfFullFilesById(row.id!);

        // Crea un objeto URL para el blob
        const url = window.URL.createObjectURL(blobData! as any);
        setDownloadFile(false);

        // Crea un enlace invisible
        const a = document.createElement("a");
        a.href = url;
        a.download = `reporte_${row.container || ""}_${row.id}.zip`; // Nombre del archivo
        document.body.appendChild(a);

        // Simula un clic para iniciar la descarga
        a.click();

        // Limpia
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        message.success("Archivo descargado correctamente", 1);
        message.success("Archivo descargado", 1);
      } catch (err) {
        setDownloadFile(false);
        enqueueSnackbar((err as Error).message, { variant: "error" });
      }
    },
    [isOffline, enqueueSnackbar, refetch]
  );

  const handleGetData = async (): Promise<void> => {
    try {
      const { data: dataClient } = await getClientIdByToken();
      if (dataClient) {
        setClient(dataClient);
        getProducers(dataClient);
      }

      const { data: dataTask } = await validTaskCodeByToken(
        TASK_FULL_FILTER_LIST
      );

      if (!dataTask) return;
      if (dataTask.status) {
        setShowExporters(true);
        const { data: dataClients } = await getAllClientsNoPagination();
        if (!dataClients) return;
        setClients(dataClients);
      }

      const { data: dataTaskPdf } = await validTaskCodeByToken(
        TASK_FULL_CREATE_PDF
      );

      if (!dataTaskPdf) return;
      if (dataTaskPdf.status) {
        setShowPdf(true);
      }
    } catch (err) {
      console.log(err);
      if (!navigator.onLine) {
        message.warning(
          "No hay conexión a internet. Funcionando en modo offline.",
          3
        );
      }
    }
  };

  const handleGetTask = async (): Promise<void> => {
    try {
      const { data: dataTask } = await validTaskCodeByToken(
        TASK_FULL_EDIT_CODE
      );

      if (!dataTask) return;
      if (dataTask.status) {
        setShowEdit(true);
      } else {
        setShowEdit(false);
      }
    } catch (err) {
      setShowEdit(false);
      console.log(err);
    }
  };

  const getFarms = React.useCallback(
    async (clientProducer: number | null): Promise<void> => {
      try {
        if (clientProducer === null) {
          setFarms([]);
          return;
        }

        const { data: dataFarms } = await getAllClientProducerFarms(
          clientProducer
        );
        if (!dataFarms) return;
        setFarms(dataFarms);
      } catch (err) {
        console.log(err);
      }
    },
    []
  );

  const getProducers = React.useCallback(
    async (clientId: number | null): Promise<void> => {
      try {
        if (clientId === null) {
          setProducers([]);
          setFarms([]);
          return;
        }

        const { data: dataProducers } = await getAllClientProducers(clientId);
        if (!dataProducers) return;
        setProducers(dataProducers);
      } catch (err) {
        console.log(err);
      }
    },
    []
  );

  const columns = React.useMemo<MRT_ColumnDef<WorkflowContainerFullI>[]>(
    () => [
      {
        accessorKey: "container",
        id: "container",
        header: "Contenedor",
        minSize: 100,
        enableClickToCopy: true,
        size: 200,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <a
              className="b-proform"
              // onClick={() => handleNavigate(row.original)}
            >
              {renderedCellValue}
            </a>
          </Box>
        ),
      },
      {
        accessorKey: "client",
        id: "client",
        header: "Cliente",
        minSize: 150,
        size: 150,
        enableClickToCopy: true,
      },
      {
        accessorKey: "producer",
        id: "producer",
        header: "Productor",
        minSize: 150,
        size: 150,
        enableClickToCopy: true,
      },
      {
        accessorKey: "farm",
        id: "farm",
        header: "Hacienda",
        minSize: 150,
        size: 150,
        enableClickToCopy: true,
      },
      {
        accessorKey: "createdAt",
        id: "createdAt",
        header: "Creacion",
        minSize: 150,
        size: 150,
      },
      {
        accessorKey: "userCreation",
        id: "userCreation",
        header: "Usuario Creación",
        minSize: 100,
        size: 200,
      },
    ],
    []
  );

  const handleDeleteRow = React.useCallback(
    async (row: WorkflowContainerFullI): Promise<void> => {
      // Validar si estamos en modo offline
      if (isOffline) {
        message.warning("No se pueden eliminar registros sin conexión", 3);
        return;
      }

      setDeleting(true);
      try {
        const { data: dataWorkflow } = await workflowContainerFullDelete(
          row.id!
        );
        enqueueSnackbar(dataWorkflow, { variant: "success" });
        refetch();
        setDeleting(false);
      } catch (err) {
        enqueueSnackbar((err as Error).message, { variant: "error" });
        setDeleting(false);
      }
    },
    [isOffline, enqueueSnackbar, refetch]
  );

  const handleExportRows = (rows: any[], columnsShow: any[]): void => {
    const headersActive = columnsShow
      .slice(2)
      .filter((el) => el.getIsVisible())
      .map((el) => ({
        label: el.columnDef.header,
        id: el.columnDef.id,
        width: el.columnDef.size,
        textAlign: "left",
        show: true,
        fontSize: "10px",
      }));

    const rowsData = rows.map((el) => el.original);

    setExportData(rowsData);
    setExportHeader(headersActive);
    setContinuoToExport(true);
  };

  const handleClickPdf = (): void => {
    setTimeout(() => {
      setReadyExport(false);
      setExportData([]);
      setExportHeader([]);
    }, 1500);
  };

  const handleResetExport = (): void => {
    setReadyExport(false);
    setExportData([]);
    setExportHeader([]);
  };

  const handleNavigate = React.useCallback(
    (row: WorkflowContainerFullI): void => {
      // Validar si estamos en modo offline para edición
      if (isOffline) {
        message.warning("En modo offline solo puede ver los detalles", 3);
        // Opcionalmente aquí podrías redirigir a una vista de solo lectura
        // o seguir con la navegación normal si tienes un manejo offline para edición
      }

      const routePath = routeEdit + row.id;
      navigate(routePath);
    },
    [isOffline, navigate]
  );

  const handlePdf = async (row: WorkflowContainerFullI): Promise<void> => {
    // Validar si estamos en modo offline
    if (isOffline) {
      message.warning("No se pueden generar PDFs sin conexión", 3);
      return;
    }

    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 20,
      });

      const { data: dataPdf } = await generateWfFullPdfReportbyId(row.id!);
      messageApi.destroy("generatePdfKey1");
      messageApi.open({
        key: "generatePdfKey4",
        type: "loading",
        content: "Procesando Pdf",
        duration: 1,
        onClose: () => {
          message.success("PDF Descargado", 1);
        },
      });

      const downloadLink = document.createElement("a");
      downloadLink.target = "__blank";
      downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
      downloadLink.download = `Reporte-Contenedor-Full-${row.container}.pdf`;
      downloadLink.click();
      setGeneratingPdf(false);
    } catch (err) {
      messageApi.destroy();
      setGeneratingPdf(false);
      message.error(
        `Error al generar el pdf: ${
          err instanceof Error ? err.toString() : "Error desconocido"
        }`
      );
    }
  };

  const handlePdfTarja = async (row: WorkflowContainerFullI): Promise<void> => {
    // Validar si estamos en modo offline
    if (isOffline) {
      message.warning("No se pueden generar PDFs sin conexión", 3);
      return;
    }

    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 20,
      });

      const { data: dataPdf } = await generateWfFullPdfTarjabyId(row.id!);
      messageApi.destroy("generatePdfKey1");
      message.success("PDF Descargado", 1);

      const downloadLink = document.createElement("a");
      downloadLink.target = "__blank";
      downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
      downloadLink.download = `TArja-${row.container}.pdf`;
      downloadLink.click();
      setGeneratingPdf(false);
    } catch (err) {
      messageApi.destroy();
      setGeneratingPdf(false);
      message.error(
        `Error al generar el pdf: ${
          err instanceof Error ? err.toString() : "Error desconocido"
        }`
      );
    }
  };

  const handleSetFarm = React.useCallback((farm: number | null): void => {
    setFarm(farm);
  }, []);

  const handleSetProducer = React.useCallback(
    (producer: number | null): void => {
      setProducer(producer);
    },
    []
  );

  const handleSetClient = React.useCallback((client: number | null): void => {
    setClient(client);
  }, []);

  // Función para generar múltiples PDFs
  const handleMultiplePdf = async (
    selectedRows: WorkflowContainerFullI[]
  ): Promise<void> => {
    // Validar si estamos en modo offline
    if (isOffline) {
      message.warning("No se pueden generar PDFs sin conexión", 3);
      return;
    }

    try {
      setGeneratingPdf(true);
      messageApi.open({
        key: "generateMultiplePdfKey",
        type: "loading",
        content: `Generando ${selectedRows.length} PDFs...`,
        duration: 0,
      });

      // Procesar cada PDF de manera secuencial para evitar sobrecarga
      for (let i = 0; i < selectedRows.length; i++) {
        const row = selectedRows[i];

        // Actualizar mensaje para mostrar progreso
        messageApi.open({
          key: "generateMultiplePdfKey",
          type: "loading",
          content: `Generando PDF ${i + 1} de ${selectedRows.length}: ${
            row.container
          }`,
          duration: 0,
        });

        try {
          const { data: dataPdf } = await generateWfFullPdfReportbyId(row.id!);

          // Descargar el PDF
          const downloadLink = document.createElement("a");
          downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
          downloadLink.target = "__blank";
          downloadLink.download = `Reporte-Contenedor-Full-${row.container}.pdf`;
          downloadLink.click();

          // Pequeña pausa para dar tiempo al navegador
          await new Promise((resolve) => setTimeout(resolve, 500));
        } catch (err) {
          console.error(`Error al generar PDF para ${row.container}:`, err);
          // Continuar con el siguiente PDF incluso si este falla
        }
      }

      messageApi.destroy("generateMultiplePdfKey");
      message.success(`Se generaron ${selectedRows.length} PDFs`, 3);
    } catch (err) {
      messageApi.destroy("generateMultiplePdfKey");
      message.error(
        `Error al generar los PDFs: ${
          err instanceof Error ? err.toString() : "Error desconocido"
        }`
      );
    } finally {
      setGeneratingPdf(false);
    }
  };

  // Función para generar múltiples tarjas
  const handleMultipleTarjas = async (
    selectedRows: WorkflowContainerFullI[]
  ): Promise<void> => {
    // Validar si estamos en modo offline
    if (isOffline) {
      message.warning("No se pueden generar Tarjas sin conexión", 3);
      return;
    }

    try {
      setGeneratingPdf(true);
      messageApi.open({
        key: "generateMultipleTarjaKey",
        type: "loading",
        content: `Generando ${selectedRows.length} Tarjas...`,
        duration: 0,
      });

      // Procesar cada Tarja de manera secuencial
      for (let i = 0; i < selectedRows.length; i++) {
        const row = selectedRows[i];

        // Actualizar mensaje para mostrar progreso
        messageApi.open({
          key: "generateMultipleTarjaKey",
          type: "loading",
          content: `Generando Tarja ${i + 1} de ${selectedRows.length}: ${
            row.container
          }`,
          duration: 0,
        });

        try {
          const { data: dataPdf } = await generateWfFullPdfTarjabyId(row.id!);

          // Descargar la Tarja
          const downloadLink = document.createElement("a");
          downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
          downloadLink.target = "__blank";
          downloadLink.download = `Tarja-${row.container}.pdf`;
          downloadLink.click();

          // Pequeña pausa para dar tiempo al navegador
          await new Promise((resolve) => setTimeout(resolve, 500));
        } catch (err) {
          console.error(`Error al generar Tarja para ${row.container}:`, err);
          // Continuar con la siguiente Tarja incluso si esta falla
        }
      }

      messageApi.destroy("generateMultipleTarjaKey");
      message.success(`Se generaron ${selectedRows.length} Tarjas`, 3);
    } catch (err) {
      messageApi.destroy("generateMultipleTarjaKey");
      message.error(
        `Error al generar las Tarjas: ${
          err instanceof Error ? err.toString() : "Error desconocido"
        }`
      );
    } finally {
      setGeneratingPdf(false);
    }
  };

  const OfflineState: React.FC = () => (
    <Empty
      image={<WifiOffIcon style={{ fontSize: 60, color: "#faad14" }} />}
      description={
        <span>Sin conexión a internet. No se pudieron cargar los datos.</span>
      }
    >
      <ButtonAntd
        type="primary"
        icon={<SyncIcon />}
        onClick={() => refetch()}
        style={{ marginRight: 8 }}
      >
        Intentar nuevamente
      </ButtonAntd>
    </Empty>
  );

  if (isOffline) return <OfflineState />;

  return (
    <>
      {contextHolder}
      <NetworkStatusAlert onRefresh={refetch} />
      <MobileFiltersModal
        visible={showMobileFilters}
        onClose={() => setShowMobileFilters(false)}
        showExporters={showExporters}
        width={width}
        clients={clients}
        producers={producers}
        farms={farms}
        getProducers={getProducers}
        getFarms={getFarms}
        setClient={handleSetClient}
        setProducer={handleSetProducer}
        setFarm={handleSetFarm}
        disabled={isOffline}
        rangeVal={rangeVal}
        setRangeVal={setRangeVal}
        setRange={setRange}
      />

      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            muiTableBodyCellProps: {
              align: "center",
            },
            size: showEdit ? 270 : 110,
            minSize: showEdit ? 270 : 110,
            maxSize: showEdit ? 270 : 110,
          },
        }}
        //OPTIONS
        enableStickyHeader
        enableStickyFooter
        enableDensityToggle
        enableColumnOrdering
        enableColumnResizing
        enableColumnFilters={false}
        enableEditing
        enableGlobalFilter
        enableRowSelection={!isOffline} // Deshabilitar selección en modo offline
        manualFiltering
        manualPagination
        manualSorting
        muiTableContainerProps={({ table }) => {
          return {
            sx: {
              minHeight: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
              maxHeight: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
              height: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
            },
          };
        }}
        muiSearchTextFieldProps={{
          placeholder: "Buscar...",
          size: "small", // Campo más pequeño
          variant: "outlined",
          InputProps: {
            startAdornment: isMaxMobile ? null : <SearchOutlined />, // Quita el icono de la lupa
          },
          style: {
            width: isMaxMobile ? "80px" : "170px", // Ancho fijo usando style en lugar de sx
            minWidth: isMaxMobile ? "80px" : "170px",
            maxWidth: isMaxMobile ? "80px" : "170px",
            margin: "0px",
          },
        }}
        muiTableBodyProps={{
          // Mostrar mensaje personalizado cuando no hay datos en modo offline
          sx: {
            "& tr.notFound": {
              height: 400,
            },
          },
        }}
        columns={columns}
        // Usar datos en caché si estamos offline y no hay datos del query
        data={data?.data?.dato || []}
        initialState={{
          density: "compact",
          rowSelection,
          sorting,
          showColumnFilters: false,
        }}
        state={{
          isLoading: (isLoading || isFetching || isRefetching) && !isOffline,
          globalFilter,
          rowSelection,
          pagination,
          sorting,
          showColumnFilters: false,
        }}
        rowCount={data?.data?.total ?? 0}
        onRowSelectionChange={setRowSelection}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        onGlobalFilterChange={setGlobalFilter}
        renderTopToolbarCustomActions={({ table }) => (
          <Grid
            alignItems="center"
            container
            justifyContent="flex-start"
            spacing={1}
            sx={{ width: "auto" }}
          >
            <Grid item>
              <Tooltip title="Refrescar">
                <span>
                  <IconButton
                    onClick={() => refetch()}
                    color="warning"
                    disabled={isOffline && !navigator.onLine} // Deshabilitar si seguimos offline
                  >
                    <RefreshIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>

            {/* Botón de sincronización para modo offline */}

            {isMobile ? (
              <Grid item>
                <ButtonAntd
                  icon={<FilterOutlined />}
                  disabled={isOffline}
                  onClick={() => setShowMobileFilters(true)}
                >
                  Filtros
                </ButtonAntd>
              </Grid>
            ) : (
              <FiltersComponent
                showExporters={showExporters}
                width={width}
                clients={clients}
                producers={producers}
                farms={farms}
                getProducers={getProducers}
                getFarms={getFarms}
                setClient={handleSetClient}
                setProducer={handleSetProducer}
                setFarm={handleSetFarm}
                disabled={isOffline}
                rangeVal={rangeVal}
                setRangeVal={setRangeVal}
                setRange={setRange}
              />
            )}

            {/* Botones de acción masiva cuando hay filas seleccionadas */}
            {(table.getIsSomeRowsSelected() ||
              table.getIsAllRowsSelected()) && (
              <>
                <Grid item>
                  <TooltipAntd title="Generar PDF para seleccionados">
                    <ButtonAntd
                      type="primary"
                      icon={<FilePdfOutlined />}
                      loading={isGeneratingPdf}
                      disabled={isGeneratingPdf || isOffline}
                      onClick={() =>
                        handleMultiplePdf(
                          table
                            .getSelectedRowModel()
                            .rows.map((row) => row.original)
                        )
                      }
                    >
                      PDFs ({table.getSelectedRowModel().rows.length})
                    </ButtonAntd>
                  </TooltipAntd>
                </Grid>

                <Grid item>
                  <TooltipAntd title="Generar Tarjas para seleccionados">
                    <ButtonAntd
                      type="primary"
                      icon={<ExceptionOutlined />}
                      loading={isGeneratingPdf}
                      disabled={isGeneratingPdf || isOffline}
                      onClick={() =>
                        handleMultipleTarjas(
                          table
                            .getSelectedRowModel()
                            .rows.map((row) => row.original)
                        )
                      }
                    >
                      Tarjas ({table.getSelectedRowModel().rows.length})
                    </ButtonAntd>
                  </TooltipAntd>
                </Grid>
              </>
            )}
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              <Tooltip arrow title="Export Data">
                <span>
                  <IconButton
                    disabled={
                      (!table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()) ||
                      isReadyExport ||
                      isOffline // Deshabilitar en modo offline
                    }
                    onClick={() =>
                      handleExportRows(
                        table.getSelectedRowModel().rows,
                        table.getAllColumns()
                      )
                    }
                    color="success"
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <PdfElement
                  data={getExportData}
                  headersColumn={getExportHeader}
                  HandleClickPdf={handleClickPdf}
                  isSmall={true}
                />
              ) : null}
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <ExcelComponent
                  data={getExportData}
                  titulo={titleExport}
                  headersColumn={getExportHeader}
                  isEcuafact={false}
                />
              ) : null}
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <Tooltip arrow title="Cancelar Exportación" placement="top">
                  <IconButton
                    onClick={handleResetExport}
                    style={{ backgroundColor: "#ECF0F1 ", color: "red" }}
                  >
                    <CancelIcon />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Grid>
          </Grid>
        )}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", gap: "0.4rem" }}>
            {showEdit ? (
              <>
                <TooltipAntd arrow={false} title="Editar">
                  <ButtonAntd
                    type="dashed"
                    size="small"
                    shape="circle"
                    onClick={() => handleNavigate(row.original)}
                    icon={<EditOutlined />}
                    disabled={isOffline} // Deshabilitar en modo offline
                  />
                </TooltipAntd>
                <TooltipAntd arrow={false} title="Multimedia">
                  <ButtonAntd
                    type="dashed"
                    size="small"
                    shape="circle"
                    onClick={() => handleDownloadFiles(row.original)}
                    icon={<FileZipFilled />}
                    disabled={isOffline || downloadFile}
                    loading={downloadFile}
                  />
                </TooltipAntd>
                <TooltipAntd arrow={false} title="Eliminar">
                  <Popconfirm
                    title="Eliminar Contenedor Full"
                    description="Seguro desea eliminar este Contenedor Full?"
                    onConfirm={() => handleDeleteRow(row.original)}
                    okText="Si"
                    cancelText="No"
                    disabled={isOffline} // Deshabilitar en modo offline
                  >
                    <ButtonAntd
                      type="dashed"
                      danger
                      loading={isDeleting}
                      disabled={isDeleting || isOffline} // Deshabilitar en modo offline
                      size="small"
                      shape="circle"
                      icon={<DeleteFilled />}
                    />
                  </Popconfirm>
                </TooltipAntd>
                <SendReport
                  id={row.original.id!}
                  typeWf="full"
                  disabled={isOffline}
                />
                <ButtonQr
                  item={row.original}
                  concatLink="workflow-full/"
                  disabled={isOffline}
                />
              </>
            ) : null}
            {showPdf ? (
              <>
                <ButtonAntd
                  loading={isGeneratingPdf}
                  disabled={isGeneratingPdf || isOffline} // Deshabilitar en modo offline
                  size="small"
                  type="dashed"
                  onClick={() => handlePdf(row.original)}
                  icon={<FilePdfOutlined />}
                />
                <TooltipAntd arrow={false} title="TARja">
                  <ButtonAntd
                    loading={isGeneratingPdf}
                    disabled={isGeneratingPdf || isOffline} // Deshabilitar en modo offline
                    size="small"
                    type="dashed"
                    onClick={() => handlePdfTarja(row.original)}
                    icon={<ExceptionOutlined />}
                  />
                </TooltipAntd>
                <ComponentModalTarjaText
                  containerId={row.original.id!}
                  containerCode={row.original.container!}
                  isOffline={isOffline}
                />
              </>
            ) : null}
            <ShowContainer id={row.original.id!} disabled={isOffline} />
          </Box>
        )}
        localization={MRT_Localization_ES}
        // OPTIONS SELECTION ROW
        selectAllMode="all"
        positionToolbarAlertBanner="none"
      />
    </>
  );
};

interface FiltersComponentProps {
  showExporters: boolean;
  width: string;
  clients: ClientI[];
  producers: ClientProducerI[];
  farms: ClientProducerFarmI[];
  getProducers: (clientId: number | null) => void;
  getFarms: (clientProducer: number | null) => void;
  setClient: (client: number | null) => void;
  setProducer: (producer: number | null) => void;
  setFarm: (farm: number | null) => void;
  disabled?: boolean;
  rangeVal: any;
  setRangeVal: any;
  setRange: any;
}

const FiltersComponent: React.FC<FiltersComponentProps> = React.memo(
  ({
    showExporters,
    width,
    clients,
    producers,
    farms,
    getProducers,
    getFarms,
    setClient,
    setProducer,
    setFarm,
    disabled = false,
    rangeVal,
    setRangeVal,
    setRange,
  }) => {
    const [producerName, setProducerName] = React.useState<string | null>(null);
    const [farmName, setFarmName] = React.useState<string | null>(null);
    const [clientName, setClientName] = React.useState<string | null>(null);

    const isMobile = width === "xs" || width === "sm" || width === "md";

    return (
      <>
        <Grid item xs={isMobile ? 12 : "auto"}>
          <ConfigProvider
            theme={{
              components: {
                DatePicker: {
                  zIndexPopup: 10500, // CAMBIADO: era 10001, ahora 10500
                },
              },
            }}
          >
            <RangePicker
              value={rangeVal}
              onChange={(dates, date) => {
                setRangeVal(dates);
                setRange(date);
              }}
              disabled={disabled}
              style={{
                width: isMobile ? "100%" : "170px",
                marginBottom: isMobile ? "8px" : "0",
              }}
              // CAMBIADO: Siempre usar document.body
              getPopupContainer={() => document.body}
              dropdownClassName={isMobile ? "mobile-date-picker-fixed" : ""}
              placeholder={["Fecha inicio", "Fecha fin"]}
              allowClear
              // AGREGADO: placement para móvil
              placement={isMobile ? "topLeft" : "bottomLeft"}
            />
          </ConfigProvider>
        </Grid>

        {showExporters && (
          <Grid item xs={isMobile ? 12 : "auto"}>
            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    zIndexPopup: 10400, // CAMBIADO: era 9999, ahora 10400
                  },
                },
              }}
            >
              <Select
                showSearch
                allowClear
                disabled={disabled}
                // CAMBIADO: Siempre usar document.body
                getPopupContainer={() => document.body}
                style={{
                  width: isMobile ? "100%" : width === "xs" ? 310 : 210,
                  minWidth: isMobile ? "100%" : width === "xs" ? 310 : 210,
                  marginBottom: isMobile ? "8px" : "0",
                }}
                placeholder="Exportador"
                optionFilterProp="label"
                filterSort={(optionA: any, optionB: any) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={clients.map((el) => ({
                  label: el.name,
                  value: el.name,
                }))}
                value={clientName}
                onChange={(value: string) => {
                  setClientName(value);
                  const findProducer = clients.find((el) => el.name === value);
                  if (findProducer) {
                    setClient(findProducer.id!);
                    getProducers(findProducer.id!);
                    getFarms(null);
                    setProducer(null);
                    setProducerName(null);
                    setFarm(null);
                    setFarmName(null);
                  } else {
                    setClient(null);
                    getProducers(null);
                    getFarms(null);
                    setProducer(null);
                    setProducerName(null);
                    setFarm(null);
                    setFarmName(null);
                  }
                }}
              />
            </ConfigProvider>
          </Grid>
        )}

        <Grid item xs={isMobile ? 12 : "auto"}>
          <ConfigProvider
            theme={{
              components: {
                Select: {
                  zIndexPopup: 10400, // CAMBIADO: era 9999, ahora 10400
                },
              },
            }}
          >
            <Select
              showSearch
              allowClear
              disabled={disabled}
              // CAMBIADO: Siempre usar document.body
              getPopupContainer={() => document.body}
              style={{
                width: isMobile ? "100%" : width === "xs" ? 310 : 200,
                minWidth: isMobile ? "100%" : width === "xs" ? 310 : 200,
                marginBottom: isMobile ? "8px" : "0",
              }}
              placeholder="Productor"
              optionFilterProp="label"
              filterSort={(optionA: any, optionB: any) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={producers.map((el) => ({
                label: el.name,
                value: el.name,
              }))}
              value={producerName}
              onChange={(value: string) => {
                setProducerName(value);
                const findProducer = producers.find((el) => el.name === value);
                if (findProducer) {
                  setProducer(findProducer.id!);
                  setFarm(null);
                  setFarmName(null);
                  getFarms(findProducer.id!);
                } else {
                  getFarms(null);
                  setProducer(null);
                  setFarm(null);
                  setFarmName(null);
                }
              }}
            />
          </ConfigProvider>
        </Grid>

        <Grid item xs={isMobile ? 12 : "auto"}>
          <ConfigProvider
            theme={{
              components: {
                Select: {
                  zIndexPopup: 10400, // CAMBIADO: era 9999, ahora 10400
                },
              },
            }}
          >
            <Select
              showSearch
              allowClear
              disabled={disabled}
              // CAMBIADO: Siempre usar document.body
              getPopupContainer={() => document.body}
              style={{
                width: isMobile ? "100%" : width === "xs" ? 310 : 180,
                minWidth: isMobile ? "100%" : width === "xs" ? 310 : 180,
                marginBottom: isMobile ? "8px" : "0",
              }}
              placeholder="Hacienda"
              optionFilterProp="label"
              filterSort={(optionA: any, optionB: any) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={farms.map((el) => ({
                label: el.name,
                value: el.name,
              }))}
              value={farmName}
              onChange={(value: string) => {
                setFarmName(value);
                const findFarm = farms.find((el) => el.name === value);
                if (findFarm) {
                  setFarm(findFarm.id!);
                } else {
                  setFarm(null);
                }
              }}
            />
          </ConfigProvider>
        </Grid>
      </>
    );
  }
);

const MobileFiltersModal: React.FC<{
  visible: boolean;
  onClose: () => void;
  showExporters: boolean;
  width: string;
  clients: ClientI[];
  producers: ClientProducerI[];
  farms: ClientProducerFarmI[];
  getProducers: (clientId: number | null) => void;
  getFarms: (clientProducer: number | null) => void;
  setClient: (client: number | null) => void;
  setProducer: (producer: number | null) => void;
  setFarm: (farm: number | null) => void;
  disabled: boolean;
  rangeVal: any;
  setRangeVal: any;
  setRange: any;
}> = ({ visible, onClose, ...filterProps }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            // zIndexPopup: 9999,
          },
          DatePicker: {
            zIndexPopup: 10500, // Z-index súper alto
          },
          Select: {
            zIndexPopup: 10400,
          },
        },
      }}
    >
      <Modal
        title="Filtros"
        open={visible}
        onCancel={onClose}
        footer={null}
        centered
        width="90%"
        style={{
          maxWidth: "400px",
          zIndex: 9999,
        }}
        bodyStyle={{
          padding: "16px",
          maxHeight: "70vh",
          overflowY: "auto",
        }}
        // CLAVE: Estas propiedades faltaban
        maskStyle={{
          zIndex: 9998,
        }}
        wrapClassName="mobile-filters-modal"
        destroyOnClose
        maskClosable={true}
      >
        <Grid container spacing={2} direction="column">
          <FiltersComponent {...filterProps} />
        </Grid>
      </Modal>
    </ConfigProvider>
  );
};

export default WorkflowListComponent;
